import { render } from "./GlobalNav.vue?vue&type=template&id=5c01a6ee&scoped=true"
import script from "./GlobalNav.vue?vue&type=script&lang=js"
export * from "./GlobalNav.vue?vue&type=script&lang=js"

import "./GlobalNav.vue?vue&type=style&index=0&id=5c01a6ee&lang=scss&scoped=true"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c01a6ee"]])

export default __exports__